import { USER_DUPLICATE_MERGE_TYPE } from '@/modules/UserDuplicatesMerges/components/constants';
import BaseModel from './base';

export default class UserDuplicateMerge extends BaseModel {
  constructor(userDuplicateMerge) {
    super(userDuplicateMerge);

    this.id = userDuplicateMerge.id;
    this.email = userDuplicateMerge.email;
    this.is_confirmed = userDuplicateMerge.is_confirmed;
    this.owner_id = userDuplicateMerge.owner_id;

    this.merge_at = userDuplicateMerge.merge_at;

    this.type = userDuplicateMerge.type || USER_DUPLICATE_MERGE_TYPE.email;
  }
}
